import { inject, Injectable, NgZone, signal } from '@angular/core';
import { Subject, merge, fromEvent, switchMap, takeUntil, timer, mapTo, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SharedIdleService {

  private idleTime = 27000000; //27000000 - 45 Minutes
  private modalTimeout = 60000; // 60 seconds - time to wait after showing modal before auto-logout

  idleExceeded = signal<boolean>(false);
  idleCheckerStarted = signal<boolean>(false);
  modalTimeout$ = signal<boolean>(false);

  private ngZone = inject(NgZone);
  private modalTimeoutSubscription: any;
  http = inject(HttpClient);

  constructor() {
  }

  public startIdleDetection() {
    this.ngZone.runOutsideAngular(() => {
      const activityEvents$ = merge(
        fromEvent(document, 'mousemove'),
        fromEvent(document, 'keydown'),
        fromEvent(document, 'click'),
        fromEvent(document, 'scroll'),
      );

      activityEvents$
        .pipe(
          switchMap(() => timer(this.idleTime).pipe(mapTo(true))),
          //takeUntil(activityEvents$),
        )
        .subscribe(() => this.ngZone.run(() => this.idleExceeded.set(true)));
    });
  }


  public startModalTimeout() {
    this.modalTimeoutSubscription = timer(this.modalTimeout).subscribe(() => {
      this.modalTimeout$.set(true);
    });
  }

  public resetModalTimeout() {
    if (this.modalTimeoutSubscription) {
      this.modalTimeoutSubscription.unsubscribe();
    }
    this.modalTimeout$.set(false);
  }

  refreshToken() : Observable<any>{
    return of(true);
  }
}
